// Tuile carte du tableau de bord du maire : la commune (ou l'arrondissement filtré) mise en avant,
// le reste grisé, les dossiers localisés en retard ou ouverts, lien vers l'écran Territoire.
import { CarteTerritoire, Lien, Squelette } from '@cc/ui';
import { useEffect, useMemo, useState } from 'react';
import { construireEchelles, fichierPourEchelle, fichiersInitiaux, marqueursDossiers, useDossiersLocalises, useLimites, useTerritoire, type NomFichier } from '../territoire/donnees';
import styles from './tableau.module.css';

export function TuileCarte({ arrondissement }: { arrondissement: string }) {
  const territoire = useTerritoire();
  const [supplementaires, setSupplementaires] = useState<NomFichier[]>([]);
  const fichiers = useMemo(() => [...new Set([...fichiersInitiaux(territoire.data), ...supplementaires])], [territoire.data, supplementaires]);
  const { limites, presentation, chargement } = useLimites(fichiers, fichiersInitiaux(territoire.data));
  const dossiers = useDossiersLocalises(true, 100);
  const echelles = useMemo(() => (territoire.data && !chargement ? construireEchelles(territoire.data, limites, presentation) : null), [territoire.data, chargement, limites, presentation]);
  const [echelle, setEchelleBrute] = useState<string | null>(null);
  const setEchelle = (id: string) => {
    const f = fichierPourEchelle(id);
    if (f) setSupplementaires((s) => (s.includes(f) ? s : [...s, f]));
    setEchelleBrute(id);
  };
  useEffect(() => {
    if (!echelles) return;
    const voulue = arrondissement ? echelles.echelles.find((e) => e.id === `arrondissement:${arrondissement}` && e.geometrie)?.id : null;
    setEchelleBrute((courante) => (courante && !arrondissement && echelles.echelles.some((e) => e.id === courante) ? courante : (voulue ?? echelles.defaut)));
  }, [echelles, arrondissement]);
  const marqueurs = useMemo(() => marqueursDossiers(dossiers.data ?? []), [dossiers.data]);
  const retards = marqueurs.filter((m) => m.ton === 'retard').length;

  return (
    <section className={styles.carteTuile} aria-labelledby="tuile-carte">
      <header>
        <h2 id="tuile-carte">Carte du territoire</h2>
        <span className={styles.fraicheur}>
          {marqueurs.length} dossier{marqueurs.length > 1 ? 's' : ''} localisé{marqueurs.length > 1 ? 's' : ''}
          {retards ? `, dont ${retards} en retard` : ''}
        </span>
        <Lien href="/territoire" className={styles.ouvrir}>
          Ouvrir le territoire
        </Lien>
      </header>
      {territoire.isError ? (
        <p className={styles.etatTuile}>Territoire indisponible.</p>
      ) : echelles && echelle ? (
        <CarteTerritoire titre="Carte du territoire" echelles={echelles.echelles} echelle={echelle} onEchelle={setEchelle} marqueurs={marqueurs} compact hauteur={300} />
      ) : (
        <Squelette hauteurBloc={300} libelle="Chargement de la carte" />
      )}
      {echelles?.mention ? <p className={styles.fraicheur}>{echelles.mention}</p> : null}
    </section>
  );
}
